import React, {
	useEffect, useState
}from "react"
import {
	Button, Popconfirm, Card, Row, Col
}from "antd"
import {
	useDispatch, useSelector
}from "react-redux"
import {
	managementActions
}from "../store/actions"
import CreateDisciplinaryActionModal from "../DisciplinaryActions/createModal"
import ModalTempExternalAdminSetting from "./modalTempExternalAdminSetting"
import i18n from "./localization"
import i18nGlobal from "../../../localization"
import history from "../../../helpers/history"
import "antd/lib/popover/style/index.css"
import "./style.css"
import CustomButton from "../../../components/ButtonCustom"
import ModalReassignSubunitUser from "./modalReassignSubunitUser"
import Reset from "../../Profile/Password/Reset"

const Actions = (props) => {
	const { userId, isTempExternalAdmin: isUserTempExternalAdmin } = props
	const dispatch = useDispatch()
	const [isVisible, setVisible] = useState(null)
	const [isTempExternalAdmin, setIsTempExternalAdmin] = useState(isUserTempExternalAdmin)
	const isRu = useSelector((state) => state.globalReducer.isRu)
	const {
		removeUserFromReOrgLoading,
		removeUserFromReOrgSuccess,
		setTempExternalAdminLoading,
		setTempExternalAdminSuccess,
		unsetTempExternalAdminLoading,
		unsetTempExternalAdminSuccess,
		createDisciplinaryActionSuccess,
		createDisciplinaryActionLoading
	} = useSelector((state) => state.managementReducer)

	const { roles } = useSelector((state) => state.userReducer)

	useEffect(() => {
		getUserExecutMethod()
	}, [])

	useEffect(() => {
		if (removeUserFromReOrgSuccess)
			history.push("/orgManagement")
	}, [removeUserFromReOrgSuccess])

	useEffect(() => {
		if (unsetTempExternalAdminSuccess)
			setIsTempExternalAdmin(false)
	}, [unsetTempExternalAdminSuccess])

	useEffect(() => {
		if (setTempExternalAdminSuccess){
			setVisible(null)
			getUserExecutHistory()
			setIsTempExternalAdmin(true)
		}
	}, [setTempExternalAdminSuccess])

	useEffect(() => {
		if (createDisciplinaryActionSuccess){
			setVisible(null)
			dispatch(managementActions.clearDisciplinaryActions())
		}
	}, [createDisciplinaryActionSuccess])

	const getUserExecutMethod = () => {
		dispatch(managementActions.getUserExecut(userId && { userId: userId }))
	}

	const dismiss = () => {
		dispatch(managementActions.removeUserFromReOrg({ userId: userId }))
	}

	const unsetTempExternalAdmin = () => {
		dispatch(managementActions.unsetTempExternalAdmin({ userId: userId }))
	}

	const setTempExternalAdmin = (values) => {
		values.userId = userId
		values.dateTo = values.dateTo.format("YYYY-MM-DD")
		dispatch(managementActions.setTempExternalAdmin(values))
	}

	const getUserExecutHistory = () => {
		dispatch(managementActions.getUserExecutHistory(userId && { userId: userId }))
	}

	const createDisciplinaryAction = (values) => {
		values.userId = userId
		dispatch(managementActions.createDisciplinaryAction(values))
	}

	return (
		<div className="actions">
			<div className="actions__buttons__wrapper">
				{ roles.includes("externalAdmin") &&
          (isTempExternalAdmin ? (
          	<Popconfirm
          		cancelText={ i18nGlobal.no[isRu] }
          		okText={ i18nGlobal.yes[isRu] }
          		title={ i18n.confirmUnset[isRu] }
          		onConfirm={ () => unsetTempExternalAdmin() }
          	>
          		<CustomButton
          			loading={ unsetTempExternalAdminLoading }
          			type="turquoise"
          		>
          			{ i18n.unsetTemporaryRights[isRu] }
          		</CustomButton>
          	</Popconfirm>
          ) : (
          	<CustomButton
          		type="turquoise"
          		onClick={ () => setVisible((state) => (state != 'TemporaryRights' ? 'TemporaryRights' : null)) }
          	>
          		{ i18n.setTemporaryRights[isRu] }
          	</CustomButton>
          )) }
				{ (roles.includes("externalAdmin") || roles.includes("tempExternalAdmin")) && (
					<>
						<CustomButton
							type="grey"
							onClick={ () => setVisible((state) => (state != 'DisciplinaryAction' ? 'DisciplinaryAction' : null)) }
						>
							{ i18n.createCreateDisciplinaryAction[isRu] }
						</CustomButton>
						<Popconfirm
							cancelText={ i18nGlobal.no[isRu] }
							okText={ i18nGlobal.yes[isRu] }
							title={ i18n.confirmDismiss[isRu] }
							onConfirm={ () => dismiss() }
						>
							<CustomButton
								loading={ removeUserFromReOrgLoading }
								type="grey"
							>
								{ i18n.dismiss[isRu] }
							</CustomButton>
						</Popconfirm>
					</>
				) }
			</div>
			{ (roles.includes("externalAdmin") || roles.includes("tempExternalAdmin")) &&
				<div className="actions__buttons__assign">
					<CustomButton
						type="grey"
						onClick={ () => setVisible("Reassign") }
					>
						{ i18n.reassign[isRu] }
					</CustomButton>
					<Reset
						userId={ userId }
					/>
				</div> }
			{
				isVisible == 'TemporaryRights' &&
				<ModalTempExternalAdminSetting
					loading={ setTempExternalAdminLoading }
					setTempExternalAdmin={ (values) => setTempExternalAdmin(values) }
				/>
			}
			{
				isVisible == 'DisciplinaryAction' &&
				<CreateDisciplinaryActionModal
					createDisciplinaryAction={ (values) => createDisciplinaryAction(values) }
					loading={ createDisciplinaryActionLoading }
				/>
			}
			{
				isVisible == 'Reassign' &&
				<ModalReassignSubunitUser
					setVisible={ setVisible }
					userId={ userId }
					visible={ isVisible }
				/>
			}
		</div>
	)
}

export default Actions
